import type { Tables } from '../services/supabase/database.types'
import type { PermissionKey } from '../features/auth/permissions'

export const ROLES = ['REQUISITANTE', 'COMPRADOR', 'ADMIN'] as const
export type Role = (typeof ROLES)[number]

export const STATUS_REQUISICAO = [
  'Nova Requisição',
  'Aberta',
  'Aguardando',
  'Em Processo de Compra',
  'Parcialmente Atendida',
  'Atendida',
  'Cancelada',
] as const
export type StatusRequisicao = (typeof STATUS_REQUISICAO)[number]

export const STATUS_ITEM = ['Em Compra', 'Cancelado', 'Atendido', 'Atendido Parcial', 'Aguardando'] as const
export type StatusItem = (typeof STATUS_ITEM)[number]

export type Profile = Omit<Tables<'profiles'>, 'role'> & { role: Role }
export type Requisicao = Omit<Tables<'requisicoes'>, 'status_geral'> & { status_geral: StatusRequisicao }
export type RequisicaoItem = Omit<Tables<'requisicao_itens'>, 'status_item'> & { status_item: StatusItem }

export interface AuthenticatedUser {
  userId: string
  email: string
  profile: Profile
  permissions?: PermissionKey[]
}
